import { useEffect } from "react";
import "@/App.css";
import { initLenis } from "@/lib/lenis";
import { Nav } from "@/components/Nav";
import { Hero } from "@/sections/Hero";
import { Marquee } from "@/sections/Marquee";
import { PathChooser } from "@/sections/PathChooser";
import { HowItWorks } from "@/sections/HowItWorks";
import { TeacherPlans } from "@/sections/TeacherPlans";
import { Library } from "@/sections/Library";
import { OwnerPlan } from "@/sections/OwnerPlan";
import { AllInOne } from "@/sections/AllInOne";
import { Comparison } from "@/sections/Comparison";
import { About } from "@/sections/About";
import { Faq } from "@/sections/Faq";
import { Footer } from "@/sections/Footer";

function App() {
  useEffect(() => {
    initLenis();
  }, []);

  return (
    <div className="App bg-alabaster text-ink">
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <PathChooser />
        <HowItWorks />
        <TeacherPlans />
        <Library kind="teacher" />
        <OwnerPlan />
        <Library kind="owner" />
        <AllInOne />
        <Comparison />
        <About />
        <Faq />
      </main>
      <Footer />
    </div>
  );
}

export default App;
